import ApiService from '@/core/services/api.service';

export * from './files.service';

const BASE_URL = 'test-drives';

export const TestDriveService = {
  getAll(params) {
    return ApiService.query(BASE_URL, { params });
  },

  getById(id) {
    return ApiService.get(`${BASE_URL}/${id}`);
  },

  create(data) {
    return ApiService.post(BASE_URL, data);
  },

  update(id, data) {
    return ApiService.patch(`${BASE_URL}/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },

  changeStatus(id, status) {
    return ApiService.patch(`${BASE_URL}/${id}/status`, { status });
  },

  exportExcel(params) {
    return ApiService.query(`${BASE_URL}/export-excel`, {
      params,
      responseType: 'blob',
    });
  },

  /**
   * @description Kiểm tra thời gian lái thử có bị trùng không
   * @param {Object} data
   * @param {string} data.id
   * @param {string} data.demoTicketId
   * @param {string} data.startTime
   * @param {string} data.endTime
   * @returns {Promise}
   */
  checkTimeConflict(data) {
    return ApiService.post(`${BASE_URL}/check-time-conflicts`, data);
  },

  /**
   * @description Kiểm tra trạng thái của phiếu lái thử trước đó
   * @param {Object} data
   * @param {string} data.id
   * @param {string} data.demoTicketId
   * @param {string} data.endTime
   * @returns {Promise}
   */
  checkPreviousTestDriveStatus(data) {
    return ApiService.post(`${BASE_URL}/check-previous-status`, data);
  },

  // Lấy danh sách xe demo
  getDemoVehicles(params) {
    return ApiService.query('demo-ticket/lookup', { params });
  },

  // Lấy danh sách lý do lái thử
  getReasons() {
    return ApiService.get(`${BASE_URL}/reasons`);
  },

  lookupDemoTickets(params) {
    return ApiService.query(`${BASE_URL}/lookup-demo-tickets`, {
      params,
    });
  },

  // Upload file đính kèm
  uploadAttachment(testDriveId, formData) {
    return ApiService.post(`${BASE_URL}/${testDriveId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Xóa file đính kèm
  deleteAttachment(testDriveId, attachmentId) {
    return ApiService.delete(
      `test-drive/${testDriveId}/attachments/${attachmentId}`,
    );
  },
};
